import PropTypes from 'prop-types'
import Image from 'components/LegacyImage'
import Link from 'components/Link'
import { articlePath } from 'libs/paths'
import { ARTICLES_TYPE } from 'types'
import { formattedDate } from '../../../components/utils'

const ArticleTiles = ({ articles }) => (
  <div className='row'>
    {articles.map((article) => (
      <Link
        className='col-12 col-md-6 col-lg-4'
        key={article.slug}
        href={articlePath(article.slug)}
        passHref
      >
        <div className='row flex-md-column align-items-center'>
          <div className='col-4 col-md-auto'>
            <Image
              alt=''
              src={article.heroImage.url}
              width={275}
              height={155}
            />
          </div>
          <div className='col-8 col-md-auto'>
            <p className='d-none d-md-block mc-opacity--muted mc-text--bold mc-text--uppercase mc-text-h7'>
              {article.category.name}
            </p>
            <h3 className='mc-text--bold mc-text--h6 mc-text--capitalize mc-mt-1'>
              {article.title}
            </h3>
            <p className='mc-opacity--muted mc-text-x-small mc-mt-1'>
              {formattedDate(article.updatedAt)}
            </p>
          </div>
        </div>
      </Link>
    ))}
  </div>
)

ArticleTiles.propTypes = {
  articles: ARTICLES_TYPE,
  error: PropTypes.bool,
}

export default ArticleTiles
